import { OrganizationType } from "@remi/enums/organization-type";
import { ExternalOrganizationTypes } from "@remi/types/organizations";

import { useOrganization } from "~/hooks/useOrganization";
import { usePerson } from "~/hooks/usePerson";
import { ExternalPersonCard } from "./contact-card/ExternalPersonCard";
import { HomeownerPersonCard } from "./contact-card/HomeownerPersonCard";
import { RemiPersonCard } from "./contact-card/RemiPersonCard";

type PersonTooltipProps = {
  personId: string;
  showButtons?: boolean;
};

export const PersonTooltipContent = ({ personId, showButtons = true }: PersonTooltipProps) => {
  const { data: person } = usePerson(personId);
  const { data: organization } = useOrganization(person?.organizationId);

  if (!person || !organization) {
    return null;
  }

  return (
    <div className="flex max-h-[min(32rem,80vh)] w-[424px] min-w-[424px] max-w-[424px] flex-col items-start overflow-y-auto bg-background-primary">
      {organization.type === OrganizationType.REMI_INTERNAL && (
        <RemiPersonCard personId={personId} showButtons={showButtons} />
      )}
      {ExternalOrganizationTypes.includes(organization.type) && (
        <ExternalPersonCard personId={personId} showButtons={showButtons} />
      )}
      {organization.type === OrganizationType.HOMEOWNER && (
        <HomeownerPersonCard personId={personId} showButtons={showButtons} />
      )}
    </div>
  );
};
